import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Table, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import EventEmitter from '../../../utils/eventEmitter';
import RulesModal from '../../modals/RulesModal';
import useRoutesAPI from '../../apis/routesAPI';
import { RxUpdate } from 'react-icons/rx';


const columns = [
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    render: (_, record) => <span>{record.action.label}</span>
  },
  {
    title: 'Source Location',
    dataIndex: 'source_location',
    key: 'source_location',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    render: (_, record) => <span>{`${record.source_location.name}`}</span>
  },
  {
    title: 'Destination',
    dataIndex: 'destination_location',
    key: 'destination_location',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    render: (_, record) => <span>{`${record.destination_location.name}`}</span>
  }
];


const locationTypes = [{value: 'internal', label: 'Internal'}, {value: 'customer_location', label: 'Customer Locations'}];
const removalOptions = [{value: 'fifo', label: 'First In First Out (FIFO)'}, {value: 'lifo', label: 'Last In First Out (LIFO)'}];


const RouteChanges = () => {
  const {locations, operations, warehouses, route} = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  // console.log(route)
  const navigate = useNavigate();
  const [name, setName] = useState(route.name ? route.name : '');
  const [enableWarehouses, setEnableWarehouses] = useState(route.warehouses ? true : false);
  const [rules, setRules] = useState(route.route_rules ? route.route_rules : []);
  const [ruleLabels, setRuleLabels] = useState([]);
  const { create, update } = useRoutesAPI();


  const onChangeName = e => setName(e.target.value);

  const onChange = e => {
    if (e.target.checked) {
      setEnableWarehouses(true);
    }else {
      setEnableWarehouses(false);
    }
  }
console.log(route)
  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name; 
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    const rules_ = rules.map(rule => ({key: rule.key, name: rule.name, seo: rule.name.toLowerCase().replace(/ /g, '-'), action: rule.action.value, operation_type_id: rule.operation_type,  destination_location: rule.destination_location.id, source_location: rule.source_location.id, supply_method: rule.supply_method && rule.supply_method}));
    create({data: data, rules: rules_}, success);
    // console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    const rules_ = rules.map(rule => ({key: rule.key, name: rule.name, seo: rule.name.toLowerCase().replace(/ /g, '-'), action: rule.action.value, operation_type_id: rule.operation_type,  destination_location: rule.destination_location.id, source_location: rule.source_location.id, supply_method: rule.supply_method && rule.supply_method}));
    update(route.seo, {data, rules: rules_}, success);
    // console.log(data);
  };


  useEffect(() => {
    EventEmitter.subscribe('route_response', data => {
      navigate('/inventory/routes/'+data);
    });
    
    return () => EventEmitter.unsubscribe('route_response');
  },[])

  const openRulesModal = () => {
    EventEmitter.dispatch('openRulesModal', true);
    // addEntry();
  }

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => {
        
        let data = {
          action: record.action.value,
          destination_location: record.destination_location.id,
          source_location: record.source_location.id,
          operation_type: record.operation_type.id,
          supply_method: record.supply_method
        };
        EventEmitter.dispatch('openAndEditRulesModal', {open: true, data});
      }
    };
  }
  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/routes'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Routes</Link> / {params.action}
          </h3>
          {!route.seo && <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>}
        </div>
        {route.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          name='name'
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Route Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form name="routes"
          form={form}
          labelAlign='left'
          labelCol={{ span: 10 }}
          labelWrap={true}
          initialValues={route.seo ? route : {
            // product: false,
            // packaging: false,
            // sales_order_line: false,
          }}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">ADDITIONAL INFORMATION</Badge> 
          <Row className='mt-5'>
            <Col md={{ span: 11 }}>
              
              <Form.Item label='Product' name="product" className='font-semibold text-gray-800 mb-2 ' valuePropName='checked' required >
                <Checkbox className='border-x-0 border-t-0 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Packaging' name="packaging" className='font-semibold text-gray-800 mb-2 ' valuePropName="checked" required >
                <Checkbox />
              </Form.Item>
            </Col>
            <Col md={{span: 10, offset: 1}}>
              <Form.Item label='Sales Order Lines' name="sales_order_line" className='font-semibold text-gray-800 mb-2 ' valuePropName='checked' required >
                <Checkbox className='border-x-0 border-t-0 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Warehouses' className='font-semibold text-gray-800 mb-2 ' required >
                <Checkbox checked={enableWarehouses} className='border-x-0 border-t-0 input-outline-none font-normal'  onChange={onChange}/>
              </Form.Item>
              {enableWarehouses && <Form.Item name="warehouses" className='font-semibold text-gray-800 mb-2 ' required >
                <Select mode='tags' options={warehouses.map(warehouse => ({value: warehouse.id, label: warehouse.name}))}/>
              </Form.Item>}
            </Col>
          </Row>
          <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">RULES</Badge>
          <Table 
            sticky
            onRow={onRow}
            rowClassName={'hover:cursor-pointer'}
            columns={columns}
            dataSource={rules}
            scroll={{ y: 400,}}
            pagination={false}
          />
          <Button onClick={openRulesModal}>Add a line</Button>
          <RulesModal 
            locations={locations} 
            operations={operations}
            // addEntry={addEntry}
            rules={rules}
            setRules={setRules}
          />
        </Form>
      </div>
    </div>
  )
}

export default RouteChanges;